import type { HabitSchedule } from '../types';

/**
 * ⚠️⚠️ A WEEKLY / MONTHLY / YEARLY HABIT NEEDS AT LEAST ONE DAY (owner, 2026-10-04).
 *
 * With none, `isHabitScheduledOn` / `isHabitDue` are false on EVERY date: the habit
 * never shows on Today, can never be completed, and sits in the list for ever. The
 * forms allowed it (un-tick every day → "0 days/week" → Create still enabled), and so
 * did the paths with no form (AI suggestions, pacts, imports).
 *
 * Why the schedule cannot be saved, in the words the form shows — or `null` when it
 * can. Daily needs no day.
 */
export function missingDaysMessage(schedule: HabitSchedule | undefined): string | null {
  switch (schedule?.interval) {
    case 'weekly':
      return schedule.days?.length ? null : 'Pick at least one day of the week';
    case 'monthly':
      return schedule.monthDays?.length ? null : 'Pick at least one day of the month';
    case 'yearly':
      return schedule.yearDates?.length ? null : 'Pick at least one date';
    default:
      return null;
  }
}

/** True when the habit could never be due — see `missingDaysMessage`. */
export function scheduleMissingDays(schedule: HabitSchedule | undefined): boolean {
  return missingDaysMessage(schedule) !== null;
}
